import job_search_simple_tabular_0 from "file:///home/wldocker/wl-cms/sites/modules/job-search-simple-tabular-widget/ui/src/job-search-simple-tabular.js";



import job_search_simple_tabular_0Stylesheet from "file:///home/wldocker/wl-cms/sites/modules/job-search-simple-tabular-widget/ui/src/job-search-simple-tabular.scss";job_search_simple_tabular_0();